class EndorseValidationScheme {
  rules;

  constructor() {
    this.rules = [];
  }

  required(options) {
    this.rules.push({
      validator: "required",
      options,
    });

    return this;
  }

  string(options) {
    this.rules.push({
      validator: "string",
      options,
    });

    return this;
  }

  number(options) {
    this.rules.push({
      validator: "number",
      options,
    });

    return this;
  }

  object(rules, options) {
    this.rules.push({
      validator: "object",
      options,
      config: { rules },
    });

    return this;
  }

  email(options) {
    this.rules.push({
      validator: "email",
      options,
    });

    return this;
  }

  url(options) {
    this.rules.push({
      validator: "url",
      options,
    });

    return this;
  }

  min(min, options) {
    this.rules.push({
      validator: "min",
      options,
      config: { min },
    });

    return this;
  }

  max(max, options) {
    this.rules.push({
      validator: "max",
      options,
      config: { max },
    });

    return this;
  }

  length(range, options) {
    this.rules.push({
      validator: "length",
      options,
      config: { range },
    });

    return this;
  }

  outside(range, options) {
    this.rules.push({
      validator: "outside",
      options,
      config: { range },
    });

    return this;
  }

  is(is, options) {
    this.rules.push({
      validator: "is",
      options,
      config: { is },
    });

    return this;
  }

  not(not, options) {
    this.rules.push({
      validator: "not",
      options,
      config: { not },
    });

    return this;
  }

  startsWith(startsWith, options) {
    this.rules.push({
      validator: "startsWith",
      options,
      config: { startsWith },
    });

    return this;
  }

  truthy(truth, options) {
    this.rules.push({
      validator: "truthy",
      options,
      config: { truth },
    });

    return this;
  }

  pattern(pattern, options) {
    this.rules.push({
      validator: "pattern",
      options,
      config: { pattern },
    });

    return this;
  }
}

function string(options) {
  return new EndorseValidationScheme().string(options);
}

function number(options) {
  return new EndorseValidationScheme().number(options);
}

function object(rules, options) {
  return new EndorseValidationScheme().object(rules, options);
}

function any() {
  return new EndorseValidationScheme();
}

export { string, number, object, any };
